import { Dialog, DialogFooter, DialogType, PrimaryButton, DefaultButton, TextField } from "@fluentui/react";
import { t } from "i18next";
// import { TextField } from "office-ui-fabric-react";
import React from "react";

interface DialogRecoveredDataProps {
  isOpen: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}

const DialogConfirmDelete: React.FC<DialogRecoveredDataProps> = ({ isOpen, onConfirm, onCancel }) => {

  const [confirmText, setConfirmText] = React.useState<boolean>(false);

  return (
    <Dialog
      hidden={!isOpen}
      dialogContentProps={{
        type: DialogType.normal,
        title: t("Eliminación masiva"),
      }}
      modalProps={{
        isBlocking: true,
      }}
      onDismiss={onCancel}
    >
      <div>
        {t("¿Deseas eliminar las actividades seleccionadas? Digita la palabra DELETE.")}
        <br />
        <br />
      </div>

      <TextField
        type="text"
        autoFocus
        onChange={(e, value) => setConfirmText(value === "DELETE")}
      ></TextField><br />

      <DialogFooter>
        <PrimaryButton onClick={onConfirm} text={t("Continuar")} disabled={!confirmText} />
        <DefaultButton onClick={onCancel} text={t("Cancelar")} />
      </DialogFooter>
    </Dialog>
  )
};

export default DialogConfirmDelete;